import './CountDown.css';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const CountDown = ({ time, onTimeUp }) => {
  CountDown.protoTypes = {
    time: PropTypes.number.isRequired,
    onTimeUp: PropTypes.func,
    className: PropTypes.string
  };

  // eslint-disable-next-line no-unused-vars
  const [biasTime, setBiasTime] = useState(new Date().getTime() + time);

  const calculateTimeLeft = () => {
    const difference = biasTime - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (isEmpty(timeLeft)) {
      if (onTimeUp) onTimeUp();
    }
  }, [timeLeft, time, onTimeUp]);

  return (
    <div className="helbest-countdown">
      {!isEmpty(timeLeft) ? `${timeLeft.minutes} : ${timeLeft.seconds}` : null}
    </div>
  );
};

export default CountDown;
